import { collectVisitorData } from '@/services/user-metrics';

/**
 * Отправляет кастомное событие в Google Analytics через gtag.
 *
 * @param {string} event - Название события/действия (например, 'click', 'submit', и т.д.).
 * @param {Record<string, unknown>} info - Дополнительная информация, ассоциированная с событием (например, стоимость покупки или счетчик).
 *
 * Пример использования:
 *   gaEvent('button_click', { event_label: 'submit_order', value: 1 });
 *
 * Перед вызовом функции убедитесь, что analytics инициализирован,
 * и window.gtag доступен.
 */
export const gaEvent = async (
  event: string,
  info?: Record<string, unknown>
) => {
  if (window.gtag) {
    const userMetrics = await collectVisitorData();
    // Отправляем все события, кроме error. error отправится ниже
    if (event !== 'error') {
      window.gtag('event', event, {
        ...(info || {}),
        ...userMetrics
      });
    }

    // Отправляем ошибку всегда, когда есть error_message или событие error
    if (info?.error_message || event === 'error') {
      window.gtag('event', 'error', {
        original_event: event,
        ...(info || {}),
        ...userMetrics
      });
    }
  }
};
